import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ProfileBanner, ProfileBannerBgWrapper, ProfileBannerBg, ProfileBannerInner, ProfileBannerHeader, ProfileBannerData, ProfileBannerTitle, ProfileBannerInfoWrapper, ProfileBannerInfo } from '@/components/custom/profile/profile-banner';
import { ProfileResume, ProfileResumeBody, ProfileResumeName, ProfileResumeEmail } from '@/components/custom/profile/profile-resume';
import { FiCalendar, FiMail, FiMapPin } from 'react-icons/fi';

const PEOPLE = [
  { name: 'Ana Silva', email: 'ana.silva@estudologia.com', img: 'https://i.pravatar.cc/150?img=20' },
  { name: 'Bruno Santos', email: 'bruno.santos@estudologia.com', img: 'https://i.pravatar.cc/150?img=21' },
  { name: 'Carla Oliveira', email: 'carla.oliveira@estudologia.com', img: 'https://i.pravatar.cc/150?img=22' }
];

export function ProfileSection() {
  return (
    <ShowcaseSection
      id="profile"
      title="Profile"
      description="Banner de perfil, chip de usuario e composicoes relacionadas"
    >
      <ShowcaseItem
        label="ProfileBanner"
        description="Hero de perfil com imagem de fundo + avatar overlap + dados do usuario"
      >
        <ProfileBanner>
          <ProfileBannerBgWrapper>
            <ProfileBannerBg
              src="https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1200&h=320&fit=crop"
              alt="capa do perfil"
            />
          </ProfileBannerBgWrapper>
          <ProfileBannerInner>
            <AvatarWrapper
              name="Maria Silva"
              image={{ url: 'https://i.pravatar.cc/200?img=25' }}
              size="lg"
            />
            <ProfileBannerHeader>
              <ProfileBannerData>
                <ProfileBannerTitle>Maria Silva</ProfileBannerTitle>
                <ProfileBannerInfoWrapper>
                  <ProfileBannerInfo>
                    <FiMail /> maria.silva@estudologia.com
                  </ProfileBannerInfo>
                  <ProfileBannerInfo>
                    <FiMapPin /> Sao Paulo, SP
                  </ProfileBannerInfo>
                  <ProfileBannerInfo>
                    <FiCalendar /> Membro desde 2024
                  </ProfileBannerInfo>
                </ProfileBannerInfoWrapper>
              </ProfileBannerData>
              <div className="flex gap-2">
                <Button variant="outline">Mensagem</Button>
                <Button>Editar perfil</Button>
              </div>
            </ProfileBannerHeader>
          </ProfileBannerInner>
        </ProfileBanner>
      </ShowcaseItem>

      <ShowcaseItem
        label="ProfileResume"
        description="Chip compacto de usuario com avatar + nome + email — usado em listas, comments, headers"
      >
        <div className="space-y-3">
          {PEOPLE.map(p => (
            <ProfileResume key={p.email}>
              <AvatarWrapper
                name={p.name}
                image={{ url: p.img }}
                size="sm"
              />
              <ProfileResumeBody>
                <ProfileResumeName>{p.name}</ProfileResumeName>
                <ProfileResumeEmail>{p.email}</ProfileResumeEmail>
              </ProfileResumeBody>
            </ProfileResume>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="ProfileResume com badge"
        description="Composicao com badge de status (admin, professor, aluno)"
      >
        <div className="space-y-3">
          <ProfileResume>
            <AvatarWrapper
              name="Joao Costa"
              image={{ url: 'https://i.pravatar.cc/150?img=30' }}
              size="sm"
            />
            <ProfileResumeBody>
              <ProfileResumeName>Joao Costa</ProfileResumeName>
              <ProfileResumeEmail>joao.costa@estudologia.com</ProfileResumeEmail>
            </ProfileResumeBody>
            <Badge variant="primary-light">Administrador</Badge>
          </ProfileResume>
          <ProfileResume>
            <AvatarWrapper
              name="Patricia Lima"
              image={{ url: 'https://i.pravatar.cc/150?img=31' }}
              size="sm"
            />
            <ProfileResumeBody>
              <ProfileResumeName>Patricia Lima</ProfileResumeName>
              <ProfileResumeEmail>patricia.lima@estudologia.com</ProfileResumeEmail>
            </ProfileResumeBody>
            <Badge variant="secondary">Professor</Badge>
          </ProfileResume>
          <ProfileResume>
            <AvatarWrapper
              name="Rafael Souza"
              image={{ url: 'https://i.pravatar.cc/150?img=32' }}
              size="sm"
            />
            <ProfileResumeBody>
              <ProfileResumeName>Rafael Souza</ProfileResumeName>
              <ProfileResumeEmail>rafael.souza@estudologia.com</ProfileResumeEmail>
            </ProfileResumeBody>
            <Badge variant="success">Aluno</Badge>
          </ProfileResume>
        </div>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
